import { render, staticRenderFns } from "./UrgeFile.vue?vue&type=template&id=b48ff6a8&scoped=true"
import script from "./UrgeFile.vue?vue&type=script&lang=js"
export * from "./UrgeFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48ff6a8",
  null
  
)

export default component.exports